<template>
    <transition appear name="fade-transition">
        <span class="display__money">
            <app-tooltip
                :value="tooltipValue"
                :disabled="displayValue === tooltipValue || (!tooltip && displayValue === fallback)"
            >
                {{ displayValue }}
            </app-tooltip>
        </span>
    </transition>
</template>

<script>
import Display from './Display';
import countries from '@/mixins/countries';
import getCurrencyFormatOptions from '@/lib/helpers/getCurrencyFormatOptions';

export default {
    name: 'DisplayMoney',
    extends: Display,
    mixins: [countries],
    computed: {
        optionsConfig() {
            let options = null;

            if (this._.isFunction(this.options)) {
                options = this.options(this.value);
            } else if (this._.isObject(this.options)) {
                options = this.options;
            } else {
                options = getCurrencyFormatOptions(this.value);
            }

            if (options && typeof options === 'object' && 'decimals' in options) {
                if (!('minimumFractionDigits' in options)) {
                    options.minimumFractionDigits = options.decimals;
                }
                if (!('maximumFractionDigits' in options)) {
                    options.maximumFractionDigits = options.decimals;
                }
            }

            return options;
        },
        amount() {
            if (!this._.has(this.value, 'amount')) {
                return null;
            }
            return this.value.amount;
        },
        currency() {
            return (
                (this.value?.currency
                    ? this.countries.find(country => country.currency.code === this.value.currency)
                    : this.countries[0]
                )?.currency || 'GBP'
            );
        },
        displayValue() {
            if ((this._.isNil(this.value) || this.value?.amount === null) && this.fallback) {
                return this.fallback;
            }
            return this.toCurrency(this.amount, this.currency.code, this.optionsConfig, this.getOption('abbreviate'));
        },
        tooltipValue() {
            return this.tooltip ? this.tooltip : this.toCurrency(this.amount, this.currency.code, 2, false);
        }
    }
};
</script>

<style lang="scss" scoped>
.display__money {
    min-width: 7rem;
    text-align: right;
}
</style>
